/* eslint-disable no-undef */
import styles from './style.styl'
import { Component, createRef } from 'preact'
import ComponentFromProp from '../component-from-prop'
import { withClass, cc, range } from '../../utils'
import { Small } from '../text'

import { IgIcon } from '../social'
import dezeen from '../../assets/images/logos/dezeen.png'
import itsNiceThat from '../../assets/images/logos/Its nice that.png'
import economist from '../../assets/images/logos/the economist.png'
import daily from '../../assets/images/linkCard/daily.jpg'
import interview from '../../assets/images/linkCard/interview.jpg'
import whatsaynew from '../../assets/images/linkCard/whatsaynew.jpg'
import Video from './Video'

const Cell = withClass(
  cc(styles.gridCell, 'centered')
)(ComponentFromProp)
const LinkCell = withClass(styles.gridCell)('a')

const videoId = '_GWp5GaFhaQ'

const createCells = (cols, rows, isMobile) => range(cols).map(col => range(rows).map(row => (
  <Cell
    className={isMobile ? styles.gridCellM : styles.gridCellD}
    style={{
      gridArea: `${row + 1} / ${col + 1} / span 1 / span 1`
    }}
  />
)))

const RotatingSquare = () => (
  <Cell className={styles.rotatingSquare}>
    <div className={styles.rotatingSquareRotated} />
  </Cell>
)

const BlackCircle = (props) => (
  <Cell {...props}>
    <div className={styles.blackCircleContent} />
  </Cell>
)

const HalfBlackCircle = () => (
  <Cell className={styles.halfBlackCircle} />
)

const VideoCell = () => {
  return (
    <Cell className={styles.video}>
      <div className={styles.videoBox}>
        <Video id={videoId} />
      </div>
    </Cell>
  )
}
const Circle = () => (
  <Cell className={styles.circleCell}>
    <div className={styles.circleBox}>
      <div className={styles.circle} />
      <div className={styles.circle} />
    </div>
  </Cell>
)

const AsSeenOn = () => (
  <Cell className={styles.asSeenOn}>
    <div className={styles.asSeenOnContent}>
      <Small>
        AS <br className={styles.isDesktop} />
        SEEN<br />
        ON<br />
      </Small>
      <div className={styles.asSeenOnLogos}>
        <img src={itsNiceThat} alt='' className={styles.itsNiceThat} />
        <img src={economist} alt='' className={styles.economist} />
        <img src={dezeen} alt='' className={styles.dezeen} />
      </div>
    </div>
  </Cell>
)

class LinkCardImage extends Component {
  ref = createRef();
  state = {
    isInView: false
  }

  intesectionCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.setState({ isInView: true })
      }
    })
  }

  componentDidMount () {
    const observer = new IntersectionObserver(this.intesectionCallback, {
      rootMargin: '0% 0% 100% 0%',
      threshold: 0
    })

    observer.observe(this.ref.current)
  }

  render () {
    return (
      <div ref={this.ref} className={styles.linkCardImageBlock} style={{ backgroundImage: this.state.isInView ? `url(${this.props.image})` : undefined }} />
    )
  }
}

const LinkCard = ({ title, href, Icon, image, classSuffix }) => {
  const getPath = () => document.getElementById(`Path${classSuffix}`)

  const onHoverAnimation = () => {
    const path = getPath()
    path.children[0].beginElement()
  }
  const onBlurAnimation = () => {
    const path = getPath()
    path.children[1].beginElement()
  }

  return (
    <LinkCell href={href} target='_blank' rel='noopener noreferrer'
      className={cc(styles.linkCard, styles[`linkCard${classSuffix}`])}
      onMouseEnter={onHoverAnimation}
      onTouchStart={onHoverAnimation}
      onMouseLeave={onBlurAnimation}
      onTouchEnd={onBlurAnimation}>
      <div className={styles.linkCardContent}>
        <div className={styles.linkCardTitle}>{title}</div>
        <div className={styles.linkCardFooter}>
          <div>{<Icon />}</div>
          <div>
            <svg width='70' height='20' viewBox='0 0 70 20' fill='none' className={styles.arrow}
              xmlns='http://www.w3.org/2000/svg'>
              <path id={`Path${classSuffix}`} d='M26 9.56543 H67.8232' stroke='black'
                strokeWidth='2'>
                <animate
                  attributeName='d'
                  dur='300ms'
                  repeatCount={undefined}
                  fill='freeze'
                  to='M0 9.56543 H67.8232' />
                <animate
                  attributeName='d'
                  dur='300ms'
                  repeatCount={undefined}
                  fill='freeze'
                  to='M26 9.56543 H67.8232' />
              </path>
              <path d='M59.1521 18.3426 L67.8232 9.67139 L59.1521 1.00021' fill='none'
                stroke='black' strokeWidth='2' />
            </svg>
          </div>
        </div>
      </div>
      <LinkCardImage image={image} />
    </LinkCell>
  )
}

const cards = [
  {
    title: <span>
      DAILY<br />
      highlights<br />
      ON<br />
      INSTAGRAM<br />
    </span>,
    href: 'https://www.instagram.com/stories/highlights/18018508936210104/',
    Icon: IgIcon,
    image: daily
  },
  {
    title: <span>
      WHAT<br />
      DELE<span className={styles.isMobile}>-<br /></span>GATES<br />
      SAY<br />
    </span>,
    href: 'https://www.folk.com.au/journal/we-re-happiest-when-we-re-learning/',
    image: whatsaynew
  },
  {
    title: <span>
      Interview<br />
      with<br />
      alumni<br />
    </span>,
    href: 'https://futurelondonacademy.co.uk/en/articles/dl-disrupting-leadership-models',
    image: interview
  }
]

const cells = createCells(17, 8)
const cellsM = createCells(7, 15, true)

const Grid = () => (
  <div className={styles.grid}>
    {cells}
    {cellsM}
    <VideoCell />
    <BlackCircle className={styles.blackCircle1} />
    <BlackCircle className={styles.blackCircle2} />
    <RotatingSquare />
    <Circle />
    <AsSeenOn />
    <HalfBlackCircle />
    <LinkCard {...cards[0]} classSuffix='First' />
    <LinkCard {...cards[1]} classSuffix='Second' />
    <LinkCard {...cards[2]} classSuffix='Third' />
  </div>
)

const FooterContent = () => (
  <div className={styles.footerContent}>
    <Grid />
  </div>
)

export default FooterContent



// WEBPACK FOOTER //
// ./components/footerContent/index.js